import { HttpParams } from '@angular/common/http';

export function httpParamsToObject(params: HttpParams): { [key: string]: string[] } {
  return params.keys().reduce<{ [key: string]: string[] }>((acc, key) => {
    acc[key] = params.getAll(key);
    return acc;
  }, {});
}
